import './Locations.css';

function TahoeCity() {
  return (
    <div className="TahoeCity">
      <h3>Tahoe City</h3>
      
      <p>The Tahoe City Ballet company did not have any boys. Ms. DeeDee and the other girls 
        frequently lamented over this, but Cyane was secretly relieved. Boys had cooties.</p>
      <p>During Nutcracker season, Ms. DeeDee was especially upset. <i>We have no Nutcracker Prince, no Rat 
        King, no Drosselmeyer, no Franz!</i> she would proclaim loudly to the retreating backs of baby ballerinas as their parents 
        clustered eagerly by the door, hoping perhaps that one of the adults would have a spare 
        boy running around their household. They usually didn’t.
      </p>

      <p>This led to creative problem-solving on Ms. DeeDee’s end: two years ago, while Cyane and 
        Kore had performed as toy soldiers and gingerbread children, the solution had been to cut 
        out the pas de deux that required men and Ms. DeeDee had dressed up as Drosselmeyer. Last 
        year, while Cyane and Kore had performed as a snowflake and the Snowflake Queen, respectively, 
        some of the parents offered to take on some of the men’s parts, leading to a hilarious spectacle 
        of untrained adults prancing about the stage.</p>

      <p>“I wonder what we will be this year,” Cyane whispers to Kore as Ms. DeeDee gathers the class 
        to go through casting and costumes. First is the Snowflake queen and a few flowers, the chocolates, 
        and the Mirlitons. Then Ms. DeeDee pulls a men's costume out of the pile, the one for Drosselmeyer.</p>

      <p>
      “Some of you young ladies are going to be in men's parts this year,” Ms. DeeDee explains 
      before handing off the Drosselmeyer costume. The Rat King was next.
      </p>
      <p>
      “Cyane, you will be dancing the part of the Prince, and Kore, you will be our magnificent Sugar Plum Fairy.”
      </p>
      <p>
      Rehearsals come and then dress rehearsals, and then it is opening night at the North Tahoe High School for 
      Ms. DeeDee’s Nutcracker. Cyane dons her Nutcracker Prince costume, sad that she won’t get to live out her 
      pancake tutu dreams this year. She eyes Kore, who is dressing beside her: her pink tutu glitters, swirls of 
      sparkles traveling up the skirt and into the bodice adorned with golden embroidery and whimsical lace. Kore 
      looks every part the dainty and elegant fairy princess. She is beautiful.
      </p>
      <p>
      Cyane’s heart thumps awkwardly. It isn’t stage fright, she thinks, because she’s danced for audiences for years now. No, it is something else...
      </p>
      <p>
      Kore turns to her and beams.
      </p>
      <p>
      Ba ba-da-da dum. Ba ba-da-da dum.
      </p>
      <p>
      The first act is quick, with Cyane’s Prince saving Clara from the rats, dying, being revived by Drosselmeyer, admiring the waltz of 
      the snowflakes with Clara clinging onto her arm. Intermission, and Cyane shakes Clara off to find Kore. Together, they run into the 
      long hallway connecting the school theater to the cafeteria/makeup room, cartwheeling and skipping and singing
      </p>
      <p><i>
      Inky binky bonky, daddy had a donkey, donkey died, daddy cried, inky binky bonky!
        </i></p>
      <p>
      “Do you think we could make it work with all the letters of the alphabet?”
      </p>
      <p>
      Cyane doesn’t respond, posing in the window reflection, pushing her face into grotesque and ghoulish positions. She’d lost 
      her last baby tooth a week before and was convinced the gap in her teeth was still noticeable when she smiled.
      </p>
      <p>
      “Whatcha lookin at?”
      </p>
      <p>
      “Can you see the gap?”
      </p>
      <p>
      “For the tooth I pulled out with the seatbelt? No.”
      </p>
      <p>
      They both stare at their reflections, and then through their reflections to the silent storm outside. 
      Snow flurries were falling in large clumps, covering cars and trees and everything else in a thick blanket. 
      The moon, full as ever, smiled at Cyane, then looked down and back up at her again. Look at the world I’ve made. 
      Everything in shades of shining silver, glinting like millions of jewels. Kore is entranced, and Cyane looks at her, 
      how her eyes reflect the diamonds scattered outside.
      </p>
      <p>
      Ba ba-da-da dum. Ba ba-da-da dum.
      </p>
      <p>
      Clara breaks their trance, coming up behind them and grabbing Cyane’s arm.
      </p>
      <p>
      “Ready for act two?”
      </p>
      <p>
      Cyane lets Clara drag her back to the theater, but glances back at Kore glowing in the light of the moon.
      </p>
      <p>
      The music resumes, the curtain rises, and Clara readjusts her grip on Cyane’s arm as they walk out into sugar 
      dreamland. Kore glides onto the stage to welcome them, curtseying. Cyane bows.
      </p>
      <p>
      Ba ba-da-da dum. Ba ba-da-da dum.
      </p>
      <p>
      They sit together on stage through the Spanish Chocolate, Arabian Coffee, and Chinese Tea dances. 
      Then the Russian dance, the Mirlitons, Mother Gigogne and the clowns. The waltz of the flowers. It’s time. 
      </p>
      <p>
      The audience applauds as the flowers leave through the wings, and Cyane extracts her arm again from Clara, 
      stepping up to invite Kore to dance. They assume their positions, arms gently reaching toward each other, and the world melts away.
      </p>
      <p>
      Ba ba-da-da dum. Ba ba-da-da dum.
      </p>
      <p>
      The sound of the harp beginning to play the pas de deux swirls like cinnamon sugar, landing softly on Cyane and Kore’s shoulders. 
      They step toward each other, and Kore lunges into a deep bow before taking Kore’s hand again to lead her into a passé. Then an 
      arabesque, Kore placing weight on Cyane’s arm for balance as Cyane spins her around. Each touch from Kore sends warmth into Cyane’s 
      limbs, her hands shaking as she supports Kore’s waist for a spinning pirouette.
      </p>
      <p>
      Cyane had always wondered why this pas de deux had been in The Nutcracker. The Prince and Clara were supposed to be in love, 
      but this dance was like an expression of desire and longing between the Prince and the Sugar Plum Fairy. And now, holding 
      Kore in her arms as they moved in a fluid motion across the stage, leaping and spinning and somehow always entwined in each 
      other, Cyane felt… sweetness, like chocolate truffles melting on her tongue, melting into her.
      </p>
      <p><i>I think I love you.</i></p>
      <p>Ba ba-da-da dum. Ba ba-da-da dum.</p>
    </div>
  );
}

export default TahoeCity;
